                                                                                                                                                                                                                                import Swal from 'sweetalert2';

const Auth = ( $ ) => {
    const $loginForm = $( '.login-form' );
    const $registerForm = $( '.register-form' );

    if ( $loginForm.length ) {
        $loginForm.on( 'submit', function( e ) {
            e.preventDefault();
            const $form = $( this );
            const $btn = $form.find( 'button.submit' );
            const $msg = $form.find( '.message' );

            $btn.prop( 'disabled', true ).find( '.loader' ).show();
            $msg.hide().removeClass( 'error success' );

            const data = {
                action: vernayApp.actionLogin,
                nonce: vernayApp.nonceLogin,
                email: $form.find( 'input[name="email"]' ).val(),
                password: $form.find( 'input[name="password"]' ).val(),
            };

            $.post( vernayApp.ajaxUrl, data, function( response ) {
                if ( response.success ) {
                    if ( response.data.redirect ) {
                        window.location.href = response.data.redirect;
                    }
                } else {
                    Swal.fire({
                        title: 'Error!',
                        text: response.data.message,
                        icon: 'error',
                        confirmButtonText: 'OK'
                    });
                    $btn.prop( 'disabled', false ).find( '.loader' ).hide();
                }
            } );
        } );
    }

    if ( $registerForm.length ) {
        $registerForm.on( 'submit', function( e ) {
            e.preventDefault();
            const $form = $( this );
            const $btn = $form.find( 'button.submit' );
            const $msg = $form.find( '.message' );

            $btn.prop( 'disabled', true ).find( '.loader' ).show();
            $msg.hide().removeClass( 'error success' );

            const data = {
                action: vernayApp.actionRegister,
                nonce: vernayApp.nonceRegister,
                fullname: $form.find( 'input[name="fullname"]' ).val(),
                email: $form.find( 'input[name="email"]' ).val(),
                company: $form.find( 'input[name="company"]' ).val(),
                phone: $form.find( 'input[name="phone"]' ).val(),
                abn: $form.find( 'input[name="abn"]' ).val(),
                industry: $form.find( 'input[name="industry"]' ).val(),
            };

            $.post( vernayApp.ajaxUrl, data, function( response ) {
                if ( response.success ) {
                    $form[ 0 ].reset();
                    Swal.fire({
                        title: 'Success!',
                        text: response.data.message,
                        icon: 'success',
                        confirmButtonText: 'OK'
                    }).then((result) => {
                        if ( response.data.redirect ) {
                            window.location.href = response.data.redirect;
                        }
                    });
                } else {
                    Swal.fire({
                        title: 'Error!',
                        text: response.data.message,
                        icon: 'error',
                        confirmButtonText: 'OK'
                    });
                    $btn.prop( 'disabled', false ).find( '.loader' ).hide();
                }
            } );
        } );
    }

    const $resetForm = $( '.reset-password-form' );

    if ( $resetForm.length ) {
        $resetForm.on( 'submit', function( e ) {
            e.preventDefault();
            const $form = $( this );
            const $btn = $form.find( 'button.submit' );

            $btn.prop( 'disabled', true ).find( '.loader' ).show();

            const data = {
                action: vernayApp.actionResetPassword,
                nonce: vernayApp.nonceResetPassword,
                email: $form.find( 'input[name="email"]' ).val(),
            };

            $.post( vernayApp.ajaxUrl, data, function( response ) {
                if ( response.success ) {
                    $form[ 0 ].reset();
                    Swal.fire({
                        title: 'Success!',
                        text: response.data.message,
                        icon: 'success',
                        confirmButtonText: 'OK'
                    });
                } else {
                    Swal.fire({
                        title: 'Error!',
                        text: response.data.message,
                        icon: 'error',
                        confirmButtonText: 'OK'
                    });
                }
                $btn.prop( 'disabled', false ).find( '.loader' ).hide();
            } );
        } );
    }

    const $accountDetailsForm = $( '.account-details-form' );

    if ( $accountDetailsForm.length ) {
        $accountDetailsForm.on( 'submit', function( e ) {
            e.preventDefault();
            const $form = $( this );
            const $btn = $form.find( 'button.submit' );

            $btn.prop( 'disabled', true ).find( '.loader' ).show();

            const data = {
                action: vernayApp.actionUpdateAccount,
                nonce: vernayApp.nonceUpdateAccount,
                fullname: $form.find( 'input[name="fullname"]' ).val(),
                email: $form.find( 'input[name="email"]' ).val(),
                company: $form.find( 'input[name="company"]' ).val(),
                phone: $form.find( 'input[name="phone"]' ).val(),
                abn: $form.find( 'input[name="abn"]' ).val(),
                industry: $form.find( 'input[name="industry"]' ).val(),
            };

            $.post( vernayApp.ajaxUrl, data, function( response ) {
                if ( response.success ) {
                    Swal.fire({
                        title: 'Success!',
                        text: response.data.message,
                        icon: 'success',
                        confirmButtonText: 'OK'
                    });
                } else {
                    Swal.fire({
                        title: 'Error!',
                        text: response.data.message,
                        icon: 'error',
                        confirmButtonText: 'OK'
                    });
                }
                $btn.prop( 'disabled', false ).find( '.loader' ).hide();
            } );
        } );
    }

    const $accountLoginForm = $( '.account-login-form' );

    if ( $accountLoginForm.length ) {
        $accountLoginForm.on( 'submit', function( e ) {
            e.preventDefault();
            const $form = $( this );
            const $btn = $form.find( 'button.submit' );

            $btn.prop( 'disabled', true ).find( '.loader' ).show();

            const data = {
                action: vernayApp.actionUpdateAccount, // Используем тот же экшен или можно разделить
                nonce: vernayApp.nonceUpdateAccount,
                email: $form.find( 'input[name="email"]' ).val(),
                password: $form.find( 'input[name="password"]' ).val(),
            };

            $.post( vernayApp.ajaxUrl, data, function( response ) {
                if ( response.success ) {
                    Swal.fire({
                        title: 'Success!',
                        text: response.data.message,
                        icon: 'success',
                        confirmButtonText: 'OK'
                    });
                    $form.find( 'input[name="password"]' ).val('');
                } else {
                    Swal.fire({
                        title: 'Error!',
                        text: response.data.message,
                        icon: 'error',
                        confirmButtonText: 'OK'
                    });
                }
                $btn.prop( 'disabled', false ).find( '.loader' ).hide();
            } );
        } );
    }
}

export default ( ( $ ) => $( Auth ) )( jQuery );
